// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconHardwareDevicesSmartphoneAddOnWarning_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s32IconSvg = html `<svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M26.75 32C29.6495 32 32 29.6495 32 26.75C32 23.8505 29.6495 21.5 26.75 21.5C23.8505 21.5 21.5 23.8505 21.5 26.75C21.5 29.6495 23.8505 32 26.75 32ZM25.771 23.3886L27.7292 22.75V27.6456H25.771V23.3886ZM25.771 28.6246H27.7292V30.5828H25.771V28.6246Z" fill="#FDCA40"/>
  <path d="M25.77 23.3886 27.7282 22.75V27.6456H25.77V23.3886ZM25.77 28.6246H27.7282V30.5828H25.77V28.6246Z" fill="#1A2329"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M24 4H8V28H19.6074C19.5368 27.5939 19.5 27.1763 19.5 26.75C19.5 24.9331 20.1684 23.2723 21.2726 22H10V6H22V21.2726C22.5907 20.76 23.2651 20.3412 24 20.0397V4ZM16.9987 25C16.9987 25.5523 16.551 26 15.9987 26C15.4464 26 14.9987 25.5523 14.9987 25C14.9987 24.4477 15.4464 24 15.9987 24C16.551 24 16.9987 24.4477 16.9987 25Z" class="svg-bg"/>
</svg>
`;
/**
 * IconHardwareDevicesSmartphoneAddOnWarning is a generated icon component.
 */
let IconHardwareDevicesSmartphoneAddOnWarning = IconHardwareDevicesSmartphoneAddOnWarning_1 = class IconHardwareDevicesSmartphoneAddOnWarning extends IconBaseElement {
    render() {
        return html `${IconHardwareDevicesSmartphoneAddOnWarning_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconHardwareDevicesSmartphoneAddOnWarning.icons = new Map([
    ['s8', _s32IconSvg],
    ['s12', _s32IconSvg],
    ['s16', _s32IconSvg],
    ['s24', _s32IconSvg],
    ['s32', _s32IconSvg],
    ['s40', _s32IconSvg],
    ['s48', _s32IconSvg],
    ['s64', _s32IconSvg],
    ['s72', _s32IconSvg],
    ['s80', _s32IconSvg],
]);
IconHardwareDevicesSmartphoneAddOnWarning = IconHardwareDevicesSmartphoneAddOnWarning_1 = __decorate([
    customElement('zui-icon-hardware-devices-smartphone-add-on-warning')
], IconHardwareDevicesSmartphoneAddOnWarning);
export { IconHardwareDevicesSmartphoneAddOnWarning };
